import React from 'react';
import { useField } from 'formik';
import styled from 'styled-components';

const VisuallyHiddenField = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  pointer-events: none;
`;


export default function MultiOptionSelect(props) {
  const { label, options, ...other } = props;
  const [field, meta, helpers] = useField(props);
  const isInvalid = meta.touched && meta.error;

  const labelClassName = props.labelClassName
  const optionContainerClassName = props.optionContainerClassName
  const optionClassName = props.optionClassName

  return (
    <label>
      <div className={`text-13px font-extrabold tracking-none uppercase font-heading mb-2 ${labelClassName}`}>{label}</div>
      <div className={`grid grid-cols-3 gap-4 text-13px text-center font-semibold font-heading ${optionContainerClassName}`}>
        {options.map((option) => (
          <div
            key={option.value}
            onClick={() => helpers.setValue(option.value)}
            className={`cursor-pointer select-none px-1 py-1.5 transition-colors duration-200 border hover:bg-blue hover:text-white hover:border-blue ${optionClassName} ${
              meta.value === option.value ? 'border-blue bg-blue text-white' : isInvalid ? 'border-[#ff0000]': 'border-black'
            }`}
            dangerouslySetInnerHTML={{ __html: option.label }}
          />
        ))}
      </div>

      <VisuallyHiddenField><input type="text" name="numberEmployees" value={meta.value} /></VisuallyHiddenField>

    </label>
  );
}
